// extracted by mini-css-extract-plugin
export default {"about":"InfoBlock_about__tQDvU"};